import {useApp} from '../../../contexts/AppContext';
import {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import config from '../../../config';
import LabelWithInfo from '../../atoms/LabelWithInfo';
import {ReportContextProvider} from '../../../contexts/ReportContext';
import moment from 'moment';
import {useParams, useNavigate, Link} from 'react-router-dom';
import {useAuth} from '../../../contexts/UserContext';
import {PageSubTitle} from '../../atoms/CommonParts';

const Page = styled.div`
`;

const PageSmallTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 10px;

  span {
    font-size: 14px;
    font-weight: bold;
    @media ${config.layout.wide} {
      font-size: 16px;
    }
  }

  &:after {
    content: '';
    display: inline-block;
    width: 10px;
    height: 1px;
    background-color: #000000;
    flex: 1 0 auto;
  }
`;

const DescriptionArea = styled.div`
  min-height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;

  div {
    padding: 24px 0;
    font-size: 24px;
    line-height: 32px;
    font-weight: bold;
    white-space: pre-wrap;
  }
`;

const ChoicesArea = styled.div`
  margin-bottom: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;

  a {
    text-decoration: none;
    color: #000000;
    height: 50px;
    line-height: 49px;
    border: 1px solid #000000;
    //padding: 0 30px;
    width: 130px;
    text-align: center;
    border-radius: 25px;
    font-weight: bold;
    font-size: 16px;
    transition: background-color 0.15s linear, border-color 0.15s linear;

    @media ${config.layout.wide} {
      &:hover {
        background-color: #000000;
        color: #fff;
        border-color: #000000;
      }
    }
  }
`;

const SubChoicesArea = styled.div`
  width: 100%;
  border-top: 1px solid #000000;
  padding-top: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 73px;

  @media ${config.layout.wide} {
    width: 360px;
    margin: 0 auto 73px;
  }

  a {
    text-decoration: none;
    color: #000000;
    height: 36px;
    line-height: 35px;
    border: 1px solid #000000;
    //padding: 0 30px;
    width: 130px;
    text-align: center;
    border-radius: 18px;
    font-weight: bold;
    font-size: 14px;
    transition: background-color 0.15s linear, border-color 0.15s linear;

    &:hover {
      background-color: #000000;
      color: #fff;
      border-color: #000000;
    }

    &.manual_top_button {
      padding-left: 9px;
    }

    &.back_button, &.manual_top_button {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='5.875' height='10.185' viewBox='0 0 5.875 10.185'%3E%3Cpath id='パス_44' data-name='パス 44' d='M5.092,0l.783.783-4.31,4.31L5.875,9.4l-.783.783L0,5.092Z' transform='translate(0 0)' fill='%23000000'/%3E%3C/svg%3E%0A");
      background-position: 15px center;
      background-repeat: no-repeat;

      &:hover {
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='5.875' height='10.185' viewBox='0 0 5.875 10.185'%3E%3Cpath id='パス_44' data-name='パス 44' d='M5.092,0l.783.783-4.31,4.31L5.875,9.4l-.783.783L0,5.092Z' transform='translate(0 0)' fill='%23ffffff'/%3E%3C/svg%3E%0A");
      }
    }
  }
`;

const SubChoicesBackButton = styled.a`
  &:hover {
    &.back_button {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='5.875' height='10.185' viewBox='0 0 5.875 10.185'%3E%3Cpath id='パス_44' data-name='パス 44' d='M5.092,0l.783.783-4.31,4.31L5.875,9.4l-.783.783L0,5.092Z' transform='translate(0 0)' fill='%23ffffff'/%3E%3C/svg%3E%0A");
    }
  }
`;

const Links = styled.div`
  padding-top: 40px;

  a {
    &:last-child {
      margin-bottom: 0;
    }

    display: block;
    margin-bottom: 20px;
    color: #000000;
    text-decoration: none;
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;

    display: flex;
    align-items: start;
    gap: 10px;

    .label {
      flex: 1 1 auto;
    }
  }
`;

const LinkIcon = styled.div`
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11.375' height='19.719' viewBox='0 0 11.375 19.719'%3E%3Cpath id='パス_44' data-name='パス 44' d='M1.515,0,0,1.515,8.344,9.859,0,18.2l1.516,1.516,9.859-9.859Z' transform='translate(0 0)' fill='%23000000'/%3E%3C/svg%3E%0A");
  display: block;
  width: 6px;
  height: 20px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  flex: 0 0 auto;
`;

const ContentSection = styled.div`
  opacity: 1;
  transition: opacity 0.2s linear;

  &.hide {
    opacity: 0;
  }
`;

const CONTENTS = {
  1: {
    description: `Do you have a CDJ-3000 or CDJ-3000X?`,
    choices: [
      {
        label: 'Yes',
        internal_link: true,
        path: '/manual/how-to-register/2',
      },
      {
        label: 'No',
        internal_link: true,
        path: '/manual/how-to-register/5',
      },
    ],
    sub_choices: [
      {
        manual_top_button: true,
      }],
    links: [],
  },
  2: {
    description: `Is the firmware version 3.20 or later?`,
    choices: [
      {
        label: 'Yes',
        internal_link: true,
        path: '/manual/how-to-register/3',
      },
      {
        label: 'No',
        internal_link: true,
        path: '/manual/how-to-register/4',
      },
    ],
    sub_choices: [
      {
        back_button: true,
      }],
    links: [],
  },
  3: {
    description: `The QR function is still under development and is only available to test partners. Please reach us for the instructions.`,
    choices: [],
    sub_choices: [
      {
        back_button: true,
      },
      {
        label: 'Device menu',
        internal_link: true,
        path: '/devices/',
      }],
    links: [
      {
        label: 'FAQ',
        internal_link: true,
        path: '/faq/',
      },
      {
        label: 'FAQ : QR code doesn’t show up.',
        internal_link: true,
        path: '/faq/#133',
      },
      {
        label: 'FAQ : Is there any way that I can  access without QR code?',
        internal_link: true,
        path: '/faq/#134',
      }],
  },
  4: {
    description: `Please update the firmware to the latest version.`,
    choices: [],
    sub_choices: [
      {
        back_button: true,
      }, {
        manual_top_button: true,
      },
    ],
    links: [
      {
        label: 'Update the CDJ-3000 FW',
        internal_link: false,
        url: 'https://www.pioneerdj.com/en/product/player/cdj-3000/black/support/',
      },
      {
        label: 'Update the CDJ-3000X FW',
        internal_link: false,
        url: 'https://support.pioneerdj.com/hc/en-us/articles/50228449553049-CDJ-3000X-Firmware',
      },
      {
        label: 'FAQ',
        internal_link: true,
        path: '/faq/',
      },
      {
        label: 'FAQ : How can I update the FW?',
        internal_link: true,
        path: '/faq/#135',
      },
      {
        label: 'Contact',
        internal_link: true,
        path: '/contact',
      },
    ],
  },
  5: {
    description: `Do you have a NXS-GW or DJM-TOUR1?`,
    choices: [
      {
        label: 'Yes',
        internal_link: true,
        path: '/manual/how-to-register/6',
      },
      {
        label: 'No',
        internal_link: true,
        path: '/manual/how-to-register/7',
      },
    ],
    sub_choices: [
      {
        back_button: true,
      }],
    links: [],
  },
  6: {
    description: `Register your device manually from the Device menu.`,
    choices: [],
    sub_choices: [
      {
        back_button: true,
      }, {
        manual_top_button: true,
      }],
    links: [
      {
        label: 'Link to Device menu',
        internal_link: true,
        path: '/devices/',
      },
      {
        label: 'FAQ',
        internal_link: true,
        path: '/faq/',
      },
      {
        label: 'FAQ : How can I find the KUVO Device ID?',
        internal_link: true,
        path: '/faq/#124',
      },
      {
        label: 'Contact',
        internal_link: true,
        path: '/contact',
      },
    ],
  },
  7: {
    description: `Sorry, you currently don’t have any eligible devices to register with KUVO.`,
    choices: [],
    sub_choices: [
      {
        back_button: true,
      }, {
        manual_top_button: true,
      }],
    links: [],
  },
};

export default function HowToRegisterPage() {
  const app = useApp();
  const auth = useAuth();
  const params = useParams();
  let step = params.step && parseInt(params.step, 10) || 1;
  const navigate = useNavigate();
  const [hiding, setHiding] = useState(false);

  if (!CONTENTS[step]) {
    step = 1;
  }
  const content = CONTENTS[step];
  console.log(step, hiding);

  useEffect(() => {
    if (auth.isLoggedIn()) {
      app.showHeader();
    } else {
      app.showHeader(true);
    }
    document.title = 'How to register your device';
    setHiding(false);
  }, [step]);

  console.log(content);

  return (
      <Page>
        <PageSubTitle>
          <span>How to register your device</span>
        </PageSubTitle>
        <ContentSection
            className={`${hiding ? 'hide' : ''}`}
        >
          <DescriptionArea>
            <div>{content.description}</div>
          </DescriptionArea>
          {
            content.choices.length ? (
                <ChoicesArea>
                  {
                    content.choices.map((c, i) => {
                      if (c.internal_link) {
                        return (
                            <a key={i} href={'#'}
                               onClick={(e) => {
                                 e.preventDefault();
                                 if (/how-to-register/.test(c.path)) {
                                   setHiding(true);
                                   setTimeout(() => {
                                     navigate(c.path);
                                   }, 300);
                                 } else {
                                   navigate(c.path);
                                 }
                               }}
                            >{c.label}</a>
                        )
                            ;
                      } else {
                        return (
                            <a key={i} href={c.url}
                               target={'_blank'}>{c.label}</a>
                        );
                      }
                    })
                  }
                </ChoicesArea>
            ) : ''
          }
          {
            content.sub_choices.length ? (
                <SubChoicesArea>
                  {
                    content.sub_choices.map(c => {
                      if (c.back_button) {
                        return (
                            <SubChoicesBackButton href={'#'} onClick={(e) => {
                              e.preventDefault();
                              setHiding(true);
                              setTimeout(() => {
                                navigate(-1);
                              }, 300);
                            }}
                                                  className={'back_button'}
                            >Back</SubChoicesBackButton>
                        );
                      } else if (c.manual_top_button) {
                        return (
                            <Link to={'/manual/'}
                                  className={'manual_top_button'}>Manual
                              Top</Link>
                        );
                      } else if (c.internal_link) {
                        return (
                            <Link to={c.path}>{c.label}</Link>
                        );
                      } else {
                        return (
                            <a href={c.url} target={'_blank'}>{c.label}</a>
                        );
                      }
                    })
                  }
                </SubChoicesArea>
            ) : ''
          }
          {
            content.links.length ? (
                <>
                  <PageSmallTitle>
                    <span>Related links</span>
                  </PageSmallTitle>
                  <Links>
                    {
                      content.links.map(c => {
                        if (c.internal_link) {
                          return (
                              <Link to={c.path}>
                                <LinkIcon/>
                                <div className={'label'}>{c.label}</div>
                              </Link>
                          );
                        } else {
                          return (
                              <a href={c.url} target={'_blank'}><LinkIcon/>
                                <div className={'label'}>{c.label}</div>
                              </a>
                          );
                        }
                      })
                    }
                  </Links>
                </>
            ) : ''
          }
        </ContentSection>
      </Page>
  );
}